module.exports = __webpack_public_path__ + "public/img/zslswx.c3533d6b.png";